import React, { useState, useContext } from 'react'
import { AppContext } from '@edx/frontend-platform/react';
import { Drawer, Button, TextInput, TextArea, Label, InlineDropdown, useToast } from '@blend-ed/blendx-ui'
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import useInsertTicket from '../../hooks/support/useInsertTicket'
import { useOrgId } from '@blend-ed/blendx-platform/hooks';
import messages from '../../components/messages';

function InputDrawerSupport({ show, setShowDrawer, refetch, intl }) {
  const { authenticatedUser } = useContext(AppContext)
  const showToast = useToast()
  const orgId = useOrgId()
  const [ticket, setTicket] = useState({
    title: '',
    type: 'Issue',
    description: '',
  })

  const placeholderMessages = {
    'Issue': messages.issuePlaceholder,
    'Bug': messages.bugPlaceholder,
    'Feature': messages.featurePlaceholder,
    'Other': messages.otherPlaceholder,
  }

  const { insertTicket, loading, error } = useInsertTicket()

  const handleChange = (name, value) => {
    setTicket({ ...ticket, [name]: value })
  }

  const handleSubmit = () => {
    insertTicket({
      variables: {
        description: ticket.description,
        title: ticket.title,
        type: ticket.type,
        raisedBy: authenticatedUser.id,
        organisationId: orgId,
      },
      onCompleted: (success) => {
        showToast('check', 'success', 'Ticket added successfully')
        refetch()
      },
      onError: (error) => {
        showToast('close', 'error', 'Something went wrong')
      }
    })
    setShowDrawer(false)
  }

  return (
    <Drawer show={show} onClose={() => setShowDrawer(false)} className="support__drawer" >
      <Drawer.Header title={intl.formatMessage(messages.supportTicketTitle)} />
      <Drawer.Body>
        <div className="support__drawer-body">
          <div className="support__drawer-body-section">
            <TextInput
              value={authenticatedUser.email}
              label="Learner Information"
              state="disabled"
            />
          </div>

          <div className="support__drawer-body-section">
            <TextInput
              value={ticket.title}
              placeholder={intl.formatMessage(messages.ticketTitlePlaceholder)}
              label={intl.formatMessage(messages.ticketTitleLabel)}
              onChange={(e) => handleChange('title', e.value)}
            />
          </div>

          <div className="support__drawer-body-section-select">
            <Label label={intl.formatMessage(messages.problemTypeLabel)} />
            <InlineDropdown border selected={ticket.type} className="support__drawer-body-section-select-dropdown" onSelect={(e) => handleChange('type', e.value)}>
              <InlineDropdown.Item label={intl.formatMessage(messages.issueType)} value="Issue" />
              <InlineDropdown.Item label={intl.formatMessage(messages.bugType)} value="Bug" />
              <InlineDropdown.Item label={intl.formatMessage(messages.featureType)} value="Feature" />
              <InlineDropdown.Item label={intl.formatMessage(messages.otherType)} value="Other" />
            </InlineDropdown>
          </div>

          <div className="support__drawer-body-section">
            <Label label={intl.formatMessage(messages.ticketDescriptionLabel)} />
            <TextArea
              value={ticket.description}
              placeholder={intl.formatMessage(placeholderMessages[ticket.type])}
              onChange={(e) => handleChange('description', e.value)}
            />
          </div>
        </div>
      </Drawer.Body>
      <Drawer.Footer className="notifications-drawer-footer">
        <Button size="xs" variant="outline-gray" onClick={() => setShowDrawer(false)}>
          {intl.formatMessage(messages.cancelButton)}
        </Button>
        <Button size="xs" variant="primary" onClick={handleSubmit}>
          {intl.formatMessage(messages.submitButton)}
        </Button>
      </Drawer.Footer>
    </Drawer>
  )
}

InputDrawerSupport.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(InputDrawerSupport);